import template from './index.html'
import controller from './controller'

export const vsName = 'machinesCloneGrid'
export const vsNgType = 'directive'

cloneFormlyGrid.$inject = []
export function cloneFormlyGrid() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: "="
    },
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}